import { network } from 'services/network';

import { QueryParams } from 'api/queries/getTemplateRelatedProjects.query';

export const getTemplateRelatedProjects = (params: QueryParams) => {
    const url = 'api/bo/phaseperformance/getTemplateRelatedProjects';
    return network.post(url, { template_id: params.templateId }).then((response) => {
        return response.data;
    });
};
